import axios from "axios";
import { getBackendUrl } from "../config";
import {
	bindApiInstance,
	clearStoredToken,
	getStoredToken,
	refreshAccessToken,
	shouldAttemptTokenRefresh,
	shouldClearSession,
} from "./authToken";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
});

bindApiInstance(api);

function applyBearer(config, token) {
	if (!token) return;
	config.headers = config.headers || {};
	if (typeof config.headers.set === "function") {
		config.headers.set("Authorization", `Bearer ${token}`);
	} else {
		config.headers.Authorization = `Bearer ${token}`;
	}
}

api.interceptors.request.use(
	(config) => {
		config.baseURL = getBackendUrl();
		applyBearer(config, getStoredToken());
		return config;
	},
	(error) => Promise.reject(error)
);

api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;
		if (!originalRequest || originalRequest.skipAuthRefresh) {
			return Promise.reject(error);
		}

		if (shouldAttemptTokenRefresh(error) && !originalRequest._retry) {
			originalRequest._retry = true;
			try {
				const data = await refreshAccessToken();
				applyBearer(originalRequest, data.token);
				return api(originalRequest);
			} catch {
				clearStoredToken();
				return Promise.reject(error);
			}
		}

		if (
			shouldClearSession(error, {
				afterRefreshRetry: Boolean(originalRequest._retry),
			})
		) {
			clearStoredToken();
		}

		return Promise.reject(error);
	}
);

export default api;
